import React, { Component } from 'react';
import GridSansCatalog from './GridSansCatalog';

class GridControllerSansCatalog extends Component {
  constructor(properties) {
    super(properties);
    this.state = {
      columns: 3,
    };
  }

  componentDidMount() {
    if (global.BROWSER) {
      this.updateColumns();
      window?.addEventListener('resize', this.updateColumns);
    }
  }

  componentWillUnmount() {
    if (global.BROWSER) {
      window?.removeEventListener('resize', this.updateColumns);
    }
  }

  updateColumns = () => {
    // determine number of tiles by DLS size of screen width
    const width = window?.innerWidth;
    // x-large
    if (width > 1280) {
      this.setState({
        columns: 3,
      });
      // large
    } else if (width > 1023 && width <= 1280) {
      this.setState({
        columns: 3,
      });
      // medium
    } else if ((width > 799) && (width <= 1023)) {
      this.setState({
        columns: 2,
      });
      // small
    } else if (width > 375 && width <= 799) {
      this.setState({
        columns: 1,
      });
      // x-small
    } else {
      this.setState({
        columns: 1,
      });
    }
  }

  render() {
    return (
      <GridSansCatalog
        {...this.props}
        columns={this.state.columns}
      />
    );
  }
}

export default GridControllerSansCatalog;
